export default __webpack_public_path__ + "static/media/April_05.22448528.png";